// KWANKGM04290_近代化資金 確認(連帯債務者等)
import React, { useState, useEffect } from 'react';
import { loan_types } from '../../Const';
import TopArea from '../../molecules/TopArea';
import Heading from '../../molecules/Heading';
import Reception from '../../templates/Reception';
import Agreement from '../../templates/Agreement';
import ExaminationChange from './ExaminationChange';
import LoadingModal from '../../molecules/LoadingModal';
import { StepNavigation as StepType } from '../../types/Template';
import { mp_flg as mp_flg_value, ma_flg as ma_flg_value } from '../../Const';
import ShowModernizationFundButton from '../../molecules/ShowModernizationFundButton';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import ShowBusinessImprovementFinancingPlanButton from '../../molecules/ShowBusinessImprovementFinancingPlanButton';
import FooterContentInquiryModernizationFundsMainDetailsInquiry from '../../organisms/FooterContentInquiryModernizationFundsMainDetailsInquiry';
import OnlineIdentificationDialog from '../../molecules/OnlineIdentificationDialog';
import Annotation from '../../atoms/Annotation';
import { status_code_list } from '../../Const';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  agreements: {
    guarantor: string;
    title: string;
    text: string;
  };
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  is_loading: boolean;
  is_disagree: boolean;
  setShowErrorNav: React.Dispatch<React.SetStateAction<boolean>>;
  mp_flg: number;
  ma_flg: number;
  step_navigation: StepType;
  callApi: (function_name: string) => Promise<any>;
  is_bank_exists: boolean;
  is_desired_bank_exists: boolean;
  is_ja_exists: boolean;
  setIsLoading: (flag: boolean) => void;
  modal_open: boolean;
  setModalnOpen: React.Dispatch<React.SetStateAction<boolean>>;
  is_implement_online_identification: boolean;
  is_guarantor_agreement: boolean;
  setIsImplementOnlineIdentification: React.Dispatch<React.SetStateAction<boolean>>;
  setIsGuarantorAgreement: React.Dispatch<React.SetStateAction<boolean>>;
  clickAgree: () => Promise<any>;
  clickDisagree: () => Promise<any>;
  is_corporate_user?: boolean;
  is_agricultural_modernization_funds?: boolean;
}

const ContentInquiryModernizationFundsMain: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  reception_id,
  reception_cd,
  status_code,
  agreements,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  is_loading,
  is_disagree,
  setShowErrorNav,
  mp_flg,
  ma_flg,
  step_navigation,
  callApi,
  is_bank_exists,
  is_desired_bank_exists,
  is_ja_exists,
  setIsLoading,
  modal_open,
  setModalnOpen,
  is_guarantor_agreement,
  is_implement_online_identification,
  setIsImplementOnlineIdentification,
  setIsGuarantorAgreement,
  clickAgree,
  clickDisagree,
  is_corporate_user,
  is_agricultural_modernization_funds,
}) => {
  useEffect(() => {
    // リロードした場合に『借入申込希望書兼経営改善資金計画書』、『借入申込書』の押下したかのセッションを削除
    if (window.performance && window.performance.navigation.type === 1) {
      sessionStorage.removeItem('item_id_33');
      sessionStorage.removeItem('item_id_32');
    }
  }, []);

  /**
   * ボタンの活性状態の制御（下記活性条件）
   *
   * ・『借入申込希望書兼経営改善資金計画書』、『借入申込書』の両ボタンが押下された場合に活性化。
   * ・ただし『借入希望書兼経営改善資金計画書』が書類提出のみで押下できない場合には、『借入申込書』ボタンのみが押下された場合に「同意書を表示する」ボタンを活性化。
   * @returns {boolean} 活性状態
   */
  const switchActivityButton = (): boolean => {
    if (!document.referrer) {
      return false;
    }

    const url = new URL(document.referrer);
    // Note 直前表示していたURLに商品IDがない場合はセッションをクリア（『借入申込希望書兼経営改善資金計画書』、『借入申込書』を押下していない）
    if (!url.searchParams.has('item_id')) {
      sessionStorage.removeItem('item_id_33');
      sessionStorage.removeItem('item_id_32');
      return false;
    } else {
      if (mp_flg === mp_flg_value.none) {
        return sessionStorage.getItem('item_id_33') === loan_types.modernization_funds;
      } else {
        return (
          sessionStorage.getItem('item_id_33') == loan_types.modernization_funds &&
          sessionStorage.getItem('item_id_32') === loan_types.business_improvement_financing_plan
        );
      }
    }
  };

  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      {/* お申込情報 */}
      <Heading size="m" label="お申込情報" />
      {/* 書類提出のみの場合は『借入申込希望書兼経営改善資金計画書』ボタンを非表示 */}
      {mp_flg !== mp_flg_value.none && (
        <ShowBusinessImprovementFinancingPlanButton
          is_session_data_register={true}
          status_code={status_code}
        />
      )}

      {/* 『借入申込書』ボタン表示 */}
      <ShowModernizationFundButton is_session_data_register={true} status_code={status_code} />

      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
        is_bank_exists={is_bank_exists}
        is_desired_bank_exists={is_desired_bank_exists}
        is_ja_exists={is_ja_exists}
        setShowErrorNav={setShowErrorNav}
        setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
        is_corporate_user={is_corporate_user}
      />
      {/* 連帯債務者等の同意不同意アコーディオン */}
      {/* 案件ステータスが借入申込保証人確認中 または 借入申込保証人不同意 かつ
          連帯債務者等が0人の場合は非表示、1人以上の場合は表示する */}
      {(status_code === status_code_list.borrowing_application_check ||
        status_code === status_code_list.borrowing_application_disagreement) &&
        guarantors_num !== 0 && (
          <Agreement
            guarantor={agreements.guarantor}
            title={agreements.title}
            text={agreements.text}
            is_disagree={is_disagree}
            is_disabled={!switchActivityButton()}
            setIsGuarantorAgreement={setIsGuarantorAgreement}
          />
        )}
      {/* ステータスが2500：借入申込保証人不同意の場合は表示する */}
      {status_code === status_code_list.borrowing_application_disagreement && (
        <Annotation
          text={
            '※他の連帯債務者等で既に不同意を表明されている方がいらっしゃる場合、同意・不同意のどちらも選択できません。'
          }
        />
      )}
      <FooterContentInquiryModernizationFundsMainDetailsInquiry
        is_staff={false}
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        is_guarantor_agreement={is_guarantor_agreement}
        is_implement_online_identification={is_implement_online_identification}
        clickAgree={clickAgree}
        clickDisagree={clickDisagree}
      />
      <OnlineIdentificationDialog
        is_guarantor={true}
        modal_open={modal_open}
        setModalnOpen={setModalnOpen}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ContentInquiryModernizationFundsMain;
